const selectClass = {
  path: "selectClass",
  component: resolve =>
    require(["../../../../pages/user/course/selectClass"], resolve)
};

export default selectClass;



// WEBPACK FOOTER //
// ./src/router/user/course/selectClassCenter/index.js